export default "/_next/static/assets/fonts/GoodOT-Medium.c289010ebc88b96b0ca162bfd70ce866.woff2";